import React from "react";
import Loader from "react-loader-spinner";

const DotsLoader = ({ isloading, color, customClass }) => {
  return (
    <div
      className={`d-flex justify-content-center ${customClass}`}
      style={{ display: isloading ? "flex" : "none" }}
    >
      <Loader
        visible={isloading}
        type="Bars"
        color={color || "#053742"}
        height={20}
      />
    </div>
  );
};

export default DotsLoader;
